module.exports = __webpack_public_path__ + "components/nearby-points/static/photo-6-6162ce2dc46143a280c00bf52338ec9e.jpg";